// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"718ccb5d","988":"9d2da500"}[chunkId] + ".chunk.js";
};